<div class="card p-3">

	<!-- Toggle Icon, Title, Button Groups -->
	<div
		class="row gx-0 card-top d-flex align-items-center {{ isExpanded ? 'is-expanded' : '' }}"
		(click)="expandSwitched.emit(!isExpanded); isExpanded = !isExpanded"
	>
		<!-- Toggle Icon -->
		<div class="col-auto pe-2 collapse-arrow">
			<i
				class="align-middle"
				[ngClass]="{
					'ft-chevron-down': isExpanded,
					'ft-chevron-right': !isExpanded
				 }"
			></i>
		</div>

		<!-- Title, Button Groups -->
		<div class="col row gx-0 align-items-center">

			<!-- Projected Title -->
			<div class="col py-2 pe-2 d-inline-block {{ hideSwitch ? 'px-0' : 'ps-0' }}">
				<ng-content select="h3"></ng-content>
			</div>

			<!-- Button Groups -->
			<div
				*ngIf="!hideSwitch"
				class="col-auto py-2 configurationModesWrapper"
			>
				<div class="btn-group btn-group-toggle" data-toggle="buttons">

					<!-- Config Modes (Global/Individual) -->
					<label
						*ngFor="let itm of configModes"
						class="btn btn-secondary"
						[ngClass]="{'active': configMode === itm.mode}"
						(click)="switchMode(itm.mode); $event.stopPropagation()"
					>
						{{ getI18nString( false, 'modals.showConfig.schedulingMode.' + itm.mode ) }}
					</label>
				</div>
			</div>
		</div>
	</div>

	<!-- Projected Content -->
	<div
		*ngIf="isExpanded"
		class="card-main-content"
	>
		<ng-content select="div.card-content"></ng-content>
	</div>
</div>
